/**
 * 打开预览：先同步开一个空白窗口（异步请求后再开会被浏览器拦截），拿到链接后再跳转。
 * 拿不到链接或出错时关闭空白窗口；断开 opener，预览页拿不到后台页面的引用。
 */
export async function openPreviewWindow(fetchUrl: () => Promise<string | null>): Promise<void> {
    const win = window.open('about:blank', '_blank');
    try {
        const url = await fetchUrl();
        if (!url) {
            win?.close();
            return;
        }
        if (win) {
            win.opener = null;
            win.location.href = url;
        } else {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    } catch (e) {
        win?.close();
        throw e;
    }
}

/** 复制文字：优先用剪贴板接口，被拒绝（如页面未获焦、内嵌浏览器无权限）时退回 execCommand */
export async function copyText(text: string): Promise<void> {
    if (navigator.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(text);
            return;
        } catch {
            // 退回 execCommand
        }
    }
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
        if (!document.execCommand('copy')) throw new Error('copy command rejected');
    } finally {
        document.body.removeChild(textarea);
    }
}
